import React from 'react';
import cn from 'classnames';

import { isTypingTarget } from '../../helpers/links_to_check_flow_helpers';
import { getUndoLinkSheet } from '../../helpers/links_to_check_helpers';
import { useWindowKeydown } from '../../hooks/useWindowKeydown';
import { useLinksToCheckContext } from './LinksToCheckContext';

import './UndoLinkSheet.scss';

/** Why our link is wrong, the check's usual reason first; a reason undoes the link and hands the card back. */
const UndoLinkSheet = () => {
  const { link, isKeysOpen, isUndoing, answer, closeSheet } = useLinksToCheckContext();
  const { title, reasons, note } = getUndoLinkSheet(link);

  const undoLink = option => answer({ kind: 'undo_link', reason: option.reason });

  useWindowKeydown(e => {
    if (isKeysOpen || isUndoing || isTypingTarget(e.target) || e.metaKey || e.ctrlKey || e.altKey) return;
    const option = reasons.find(reason => reason.shortcut === e.key);
    if (e.key === 'Escape') closeSheet();
    else if (option) undoLink(option);
    else return;
    e.preventDefault();
  });

  return (
    <div className='undo-link-sheet' role='dialog' aria-label={title}>
      <h3>{title}</h3>
      {reasons.map(option => (
        <button
          key={option.reason}
          type='button'
          className={cn('sheet-option', { usual: option.usual })}
          disabled={isUndoing}
          onClick={() => undoLink(option)}
        >
          <span className='ltc-key'>{option.shortcut}</span>
          <span className='option-title'>
            {option.display}
            {option.usual && <span className='option-usual'>usual for this check</span>}
          </span>
        </button>
      ))}
      <div className='sheet-muted'>{note}</div>
    </div>
  );
};

export default UndoLinkSheet;
